import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, AttributesState } from './attributes.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import { Attribute } from '@emm/core/models/attribute.model';
import {SearchFilter} from '@emm/core/models/search-filter';

const getState = createSelector(getManagementState, (state: ManagementState) => state.attributes);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getAllGlobal = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);
const getSelectedTag = createSelector(getState, (state: AttributesState) => state.selectedTag);
const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);
const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);
const getSearchFilter = createSelector(getState, (state: AttributesState) => state.searchFilter);
const getFilteredAttributes = createSelector(
    getValidAll,
    getSearchFilter,
    (attributes: Attribute[], filter: SearchFilter) => {
        const useFilter =
            RA.isNonEmptyArray(attributes) &&
            RA.isNotNilOrEmpty(filter) &&
            RA.isNonEmptyString(filter.key) &&
            RA.isNotNil(filter.value);

        const filterString = (filter?.value as string)?.toLowerCase();

        const filteredItems = attributes?.filter((item: Attribute) => {
            if (filter?.key === 'locked') {
                let val: boolean;

                if (filterString === 'false') {
                    val = false;
                } else if (filterString === 'true') {
                    val = true;
                }

                return item[filter?.key] === val;
            } else {
                return item[filter?.key] && item[filter?.key].toLowerCase().includes(filterString);
            }
        });

        return useFilter ? filteredItems : attributes;
    }
);
const getAttributeTypes = createSelector(getState, (state: AttributesState) => state.attributeTypes);

export const AttributesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getAllGlobal,
    getSelected,
    getValidAll,
    getFilteredAttributes,
    getAttributeTypes
};
